module.exports = __webpack_public_path__ + "static/media/camera-off.faddeb40.png";